<template>
  <div class="row">
    <div class="col">
      <div class="btn-toolbar" role="toolbar">
        <button @click="saveLogin" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/><br/>
      </div>
      <div class="form-group">
        <label>Login:</label>
        <input class="form-control" type="text" v-model="login.login"/>
      </div>
      <div class="form-group">
        <label>Passwort:</label><br/>
        <input class="form-control" type="password" v-model="login.password"/>
      </div>
      <div class="form-group">
        <label>Wiederholung:</label><br/>
        <input class="form-control" type="password" v-model="login.repeat"/>
      </div>
      <div class="form-check">
        <input id="loginActivate" type="checkbox" class="form-check-input" v-model="login.active"/>
        <label for="loginActivate">Aktiviert</label>
      </div>
    </div>
    <div class="col">
      <div class="btn-toolbar" role="toolbar">
        <button @click="createKey" class="btn btn-primary"><font-awesome-icon icon="new"/>&nbsp;API Key erstellen</button><br/><br/>
      </div>
      <div class="m-3">
        <ul class="list-group">
          <li v-for="ak in apikeys" :key="ak.id" class="list-group-item d-flex justify-content-between"><span>*******/{{ak.id}}</span><font-awesome-icon @click="deleteKey(ak.id)" icon="trash"/></li>
        </ul>
      </div>
    </div>
    <b-modal id="apikeyView" ok-only>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>
              Ihr neue API Key (bitte gut merken, kann nur hier und jetzt gelesen werden)
            </label>
            <strong>
              {{ newkey }}
            </strong>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import sysuser from '@/modules/sysuser.js'

export default {
  name: 'UserLogin',
  props: ['userid'],
  data() {
    return {
      login: {},
      apikeys: [],
      newkey: ''
    }
  },
  mounted: function() {
    var self = this;
    this.login.userid = this.userid;
    if (this.userid !== '0' && this.userid !== 'new') {
      sysuser.logindata(this,this.userid,function(data) {
        self.login = data;
        self.$emit('loaded');
      })
      this.updateAPIKeys();
    }
  },
  methods: {
    updateAPIKeys: function() {
      var self = this;
      sysuser.listapikeys(this,this.userid,function(data) {
        self.apikeys = data;
      })
    },
    deleteKey: function(kid) {
      var self = this;
      sysuser.deleteapikey(this,this.userid,kid,function() {
        self.$bvToast.toast('API Key wurde gelöscht.',{title: 'API Keys',variant: 'success'});
        self.updateAPIKeys();
      })
    },
    createKey: function() {
      var self = this;
      sysuser.createapikey(this,this.userid,function(data) {
        console.log('new key: ' + data.apikey);
        self.newkey = data.apikey;
        self.$bvModal.show('apikeyView');
        self.updateAPIKeys();
      })
    },
    saveLogin: function() {
      console.log(this.login);
      if (!this.login.password || this.login.password == '') {
        this.$bvToast.toast('Leeres Passwort nicht erlaubt.',{title: 'Benutzer Login',variant:'warning'});
        return;
      }
      if (this.login.password != this.login.repeat) {
        this.$bvToast.toast('Passwortwiederholung stimmt nicht überein.',{title: 'Benutzer Login',variant:'warning'});
        return;
      }
      var self = this;
      this.login.userid = this.userid; // update userid if new user
      sysuser.savelogin(this,this.login,function(data) {
        self.$bvToast.toast('Login gespeichert',{title: 'Benutzer Login',variant:'success'});
        console.log(data);
      })
    }
  }
}
</script>
